import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoSq: CultureInfo = {
  name: 'sq',
  displayName: 'Albanian',
  iso3LanguageCode: 'sqi',
  iso2LanguageCode: 'sq',
  ietfLanguageTag: 'sq',
  parent: null
};
